import { useCallback, useEffect, useState } from 'react';

export type ViewMode = 'grid' | 'feed';

let currentMode: ViewMode = 'grid';
const listeners = new Set<() => void>();

export function useViewMode(): [ViewMode, (mode: ViewMode) => void] {
  const [viewMode, setViewModeState] = useState<ViewMode>(currentMode);

  useEffect(() => {
    const listener = () => setViewModeState(currentMode);
    listeners.add(listener);
    return () => {
      listeners.delete(listener);
    };
  }, []);

  const setViewMode = useCallback((mode: ViewMode) => {
    currentMode = mode;
    listeners.forEach((l) => l());
  }, []);

  return [viewMode, setViewMode];
}
